import React, { useCallback } from 'react';
function SubmitIcon() {
    return (React.createElement("svg", { className: "ais-SearchBox-submitIcon", width: "10", height: "10", viewBox: "0 0 40 40", "aria-hidden": "true" },
        React.createElement("path", { d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" })));
}
function ResetIcon() {
    return (React.createElement("svg", { className: "ais-SearchBox-resetIcon", viewBox: "0 0 20 20", width: "10", height: "10", "aria-hidden": "true" },
        React.createElement("path", { d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" })));
}
export default function SearchBox({ inputRef, placeholder, translations, value, onChange, onSubmit, onReset, }) {
    const handleSubmit = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        if (onSubmit) {
            onSubmit();
        }
        if (inputRef.current) {
            inputRef.current.blur();
        }
    }, [inputRef, onSubmit]);
    const handleReset = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
        onReset();
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [inputRef, onReset]);
    return (React.createElement("div", { className: "ais-SearchBox" },
        React.createElement("form", { noValidate: true, className: "ais-SearchBox-form", action: "", role: "search", onSubmit: handleSubmit, onReset: handleReset },
            React.createElement("input", { ref: inputRef, className: "ais-SearchBox-input", "aria-label": "Search", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", placeholder: placeholder, spellCheck: false, maxLength: 512, type: "search", value: value, onChange: onChange, onCompositionEnd: onChange }),
            React.createElement("button", { className: "ais-SearchBox-submit", type: "submit", title: translations.submitButtonTitle, "aria-label": translations.submitButtonTitle },
                React.createElement(SubmitIcon, null)),
            React.createElement("button", { className: "ais-SearchBox-reset", type: "button", hidden: value.length === 0, title: translations.resetButtonTitle, "aria-label": translations.resetButtonTitle },
                React.createElement(ResetIcon, null)))));
}
